/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'video-circle-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<desc>meeting stream camera</desc><g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M12 1.51a10.5 10.5 0 100 21 10.5 10.5 0 100-21z"/><path pid="1" d="M18 9.011l-3 1v-1 0c0-.83-.68-1.5-1.5-1.5H7.49c-.83 0-1.5.67-1.5 1.5 0 0 0 0 0 0v6h0c0 .82.67 1.49 1.5 1.49h6-.01c.82 0 1.5-.68 1.5-1.5v-1l3 1z"/></g>'
  }
})
